import { defineStore } from 'pinia';
import FollowUpTemplatesAPI from 'dashboard/api/followUpTemplates';

export const useFollowUpTemplatesStore = defineStore('followUpTemplates', {
  state: () => ({
    list: [],
    current: null,
    loading: false,
  }),
  actions: {
    async fetchAll(params = {}) {
      this.loading = true;
      try {
        const { data } = await FollowUpTemplatesAPI.index(params);
        this.list = data;
        return data;
      } finally {
        this.loading = false;
      }
    },
    async fetchOne(id) {
      const { data } = await FollowUpTemplatesAPI.show(id);
      this.current = data;
      return data;
    },
    async create(payload) {
      const { data } = await FollowUpTemplatesAPI.create({
        follow_up_template: payload,
      });
      this.list = [data, ...this.list];
      return data;
    },
    async update(id, payload) {
      const { data } = await FollowUpTemplatesAPI.update(id, {
        follow_up_template: payload,
      });
      // updateBumps version => substitui na lista
      this.list = this.list.map(t => (t.id === id ? data : t));
      return data;
    },
    async duplicate(id) {
      const { data } = await FollowUpTemplatesAPI.duplicate(id);
      this.list = [data, ...this.list];
      return data;
    },
    async activate(id) {
      const { data } = await FollowUpTemplatesAPI.activate(id);
      this.list = this.list.map(t => (t.id === id ? data : t));
      return data;
    },
    async deactivate(id) {
      const { data } = await FollowUpTemplatesAPI.deactivate(id);
      this.list = this.list.map(t => (t.id === id ? data : t));
      return data;
    },
    async destroy(id) {
      await FollowUpTemplatesAPI.delete(id);
      this.list = this.list.filter(t => t.id !== id);
    },
    async createStep(templateId, payload) {
      const { data } = await FollowUpTemplatesAPI.createStep(
        templateId,
        payload
      );
      return data;
    },
    async updateStep(templateId, id, payload) {
      const { data } = await FollowUpTemplatesAPI.updateStep(
        templateId,
        id,
        payload
      );
      return data;
    },
    async destroyStep(templateId, id) {
      await FollowUpTemplatesAPI.destroyStep(templateId, id);
    },
    async reorderSteps(templateId, positions) {
      await FollowUpTemplatesAPI.reorderSteps(templateId, positions);
    },
    // Gera o conteúdo do passo via IA (Captain) e devolve o texto gerado.
    async generateStepContent(templateId, step) {
      const { data } = await FollowUpTemplatesAPI.generateStepContent(
        templateId,
        step
      );
      return data.content;
    },
  },
});
